import React, { useState, useEffect } from 'react'
import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'
import DesktopContent from './components/DesktopContent/DesktopContent'
import defaultBackground from './assets/background/background-1.jpg'
import './App.css'
import './styles/global.css'

function App() {
  const [backgroundImage, setBackgroundImage] = useState(() => {
    // 从 localStorage 获取背景图片
    return localStorage.getItem('backgroundImage') || defaultBackground
  })

  const updateBackgroundImage = newImage => {
    setBackgroundImage(newImage)
    // 将新的背景图片存储到 localStorage
    localStorage.setItem('backgroundImage', newImage)
  }

  return (
    <div
      className="app"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Header title="EaseSite" />
      <DesktopContent />
      <Footer onChangeBackground={updateBackgroundImage} />
    </div>
  )
}

export default App
